import {
  withTranslation,
} from 'react-i18next';

import ContactsSectionView from './ContactsSectionView';

const TranslatedComponent = withTranslation()(ContactsSectionView);

const Component = TranslatedComponent;

export default Component;
